import styled from "styled-components";

export const ModalOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.33);
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 99;
  overflow: hidden;
`;
export const StyledSearchModal = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  padding: 30px;
  color: ${({ theme }) => theme.colors.text};
  position: fixed;
  top: 50px;
  overflow: hidden;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 999;
  border-radius: 40px 40px 0 0;
  flex-direction: column;
  gap: 20px;
  box-shadow: ${({ theme }) =>
    theme.colors.background === "#171717"
      ? "0px 4px 20px rgba(0, 0, 0, 0.5), 0px 1px 5px rgba(255, 255, 255, 0.1)"
      : "0px -10px 40px rgba(0, 0, 0, 0.10)"};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    //min-width: max-content;
    bottom: 2%;
    top: 2%;
    left: 28%;
    right: 28%;
    border-radius: 40px;
  }
  h2 {
    font-size: 20px;
    margin-top: 0;
  }
`;

export const StyledInput = styled.input`
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 12px;
  font-size: 12px;
  width: 100%;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: #b1b1b1;
  }
  &::after {
    content: "show";
    display: block;
  }
`;

export const CalendarWrapper = styled.div`
  margin: 16px 0;

  .react-calendar {
    width: 100%;
    border: none;
    font-family: "Poppins", sans-serif;
    line-height: 2.5;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.text};
    font-size: 12px;
    gap: 4px;
    abbr {
      text-decoration: none;
      text-transform: capitalize;
    }

    .react-calendar__navigation {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;

      button {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.text};
      }
    }

    .react-calendar__tile {
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      &:hover {
        background-color: ${({ theme }) => theme.colors.card};
        color: ${({ theme }) => theme.colors.text};
      }
    }
    .react-calendar__tile--now {
      background: ${({ theme }) => theme.colors.card};
    }

    .react-calendar__tile--range {
      background: ${({ theme }) => theme.colors.button};
      color: ${({ theme }) => theme.colors.buttonFont};
      border-radius: 4px;
    }
    .react-calendar__month-view__days__day--weekend {
      color: ${({ theme }) => theme.colors.text};
    }
    .react-calendar__tile:disabled {
      color: #ababab;
    }
    .react-calendar__tile:hover {
      //outline: 1px solid;
      background-color: ${({ theme }) => theme.colors.button};
      color: ${({ theme }) => theme.colors.buttonFont};
    }
    .react-calendar__tile--range {
      background: ${({ theme }) => theme.colors.button};
      color: ${({ theme }) => theme.colors.buttonFont};
    }
    .react-calendar .available {
      background-color: #ffffff;
    }

    .react-calendar .unavailable {
      background-color: ${({ theme }) => theme.colors.card};
      color: #999;
      cursor: not-allowed;
    }
    .react-calendar__tile.react-calendar__month-view__days__day.react-calendar__month-view__days__day.unavailable {
      background-color: ${({ theme }) => theme.colors.card};
      color: ${({ theme }) => theme.colors.text};
    }
    .react-calendar .in-range {
      background-color: #e6f3ff;
    }

    .react-calendar .invalid-range {
      background-color: #ffe6e6;
    }
    .react-calendar__tile--range .available {
      background: ${({ theme }) => theme.colors.button};
      color: ${({ theme }) => theme.colors.buttonFont};
    }
  }
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 30px;
  right: 20px;
  left: 20px;
`;

export const GuestSelectorWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.card};
  padding: 0px 20px 20px 20px;
  margin-top: -22px;
  border: 0.5px solid #00000030;
  border-top: none;
  border-radius: 0 0 12px 12px;
  z-index: -1;
  font-size: 12px;
`;
export const GuestSelectorButton = styled.div`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
  border-radius: 50%;
  cursor: pointer;
`;
export const GuestCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
`;
